if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      if (!variantId) return;

      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(() => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      if (variant?.available) {
        this.fetchAvailability(variant.id);
      } else {
        this.removeAttribute('available');
        this.innerHTML = '';
      }
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

      const button = this.querySelector('button');
      if (button)
        button.addEventListener('click', (evt) => {
          document.querySelector('pickup-availability-drawer').show(evt.target);
        });
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);
      this.onToggleStoreDetails = this.onToggleStoreDetails.bind(this);

      // Close button is always the first <button> in the drawer
      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });

      this.addEventListener('click', this.onToggleStoreDetails);
      this.addEventListener('click', this.onFilterToggle.bind(this));
      this.initPillListeners();
    }

    // ✅ NEW FUNCTION (your requirement)
    applySpecialLocationMessages() {
      const panel = this; // safer than ID

      const inner = panel.querySelector('[data-special-tags]');
      const specialTagsStr = inner ? inner.getAttribute('data-special-tags').trim() : '';

      const productTagsStr = (this.dataset.productTags || '').trim();

      const specialMessage = (this.dataset.specialMessage || '')
        .replace(/\\n/g, '\n')
        .trim();

      const specialTagsList = specialTagsStr
        ? specialTagsStr.split(',').map(t => t.trim().toUpperCase()).filter(Boolean)
        : [];

      const productTagsList = productTagsStr
        ? productTagsStr.split(',').map(t => t.trim().toUpperCase()).filter(Boolean)
        : [];

      const productHasSpecialTag =
        specialTagsList.length > 0 &&
        productTagsList.some(pt => specialTagsList.includes(pt));

      panel.querySelectorAll('.pickup-availability-list__item[data-is-special-location="true"]').forEach((item) => {
        const span = item.querySelector('.pickup-availability-list__in-stock-text');

        if (span && productHasSpecialTag && specialMessage) {
          span.textContent = specialMessage;
          span.classList.add('pickup-availability-list__in-stock-text--multiline');
        }
      });
    }

    onFilterToggle(evt) {
      const toggle = evt.target.closest('[data-pickup-filter-toggle]');
      if (!toggle) return;
      const isOn = toggle.getAttribute('aria-checked') === 'true';
      toggle.setAttribute('aria-checked', isOn ? 'false' : 'true');
      this.applyAvailabilityFilter();
    }

    applyAvailabilityFilter() {
      const toggle = this.querySelector('[data-pickup-filter-toggle]');
      const showAvailableOnly = toggle && toggle.getAttribute('aria-checked') === 'true';
      this.querySelectorAll('.pickup-availability-list__item').forEach(item => {
        const isAvailable = !!item.querySelector('.pickup-availability-status--available');
        item.hidden = showAvailableOnly && !isAvailable;
      });
    }

    onToggleStoreDetails(evt) {
      const toggle = evt.target.closest('[data-pickup-availability-toggle]');
      if (!toggle) return;

      const controlsId = toggle.getAttribute('aria-controls');
      if (!controlsId) return;

      const details = this.querySelector(`#${CSS.escape(controlsId)}`);
      if (!details) return;

      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      details.hidden = isExpanded;
    }

    initPillListeners() {
      this.querySelectorAll('.pickup-availability-pill').forEach(pill => {
        pill.addEventListener('click', (evt) => this.handlePillClick(evt));
      });
    }

    handlePillClick(evt) {
      const pill = evt.target.closest('.pickup-availability-pill');
      if (!pill || pill.getAttribute('aria-disabled') === 'true') return;
      if (pill.classList.contains('pickup-availability-pill--selected')) return;

      const optionPosition = parseInt(pill.dataset.optionPosition, 10);
      const optionValue = pill.dataset.optionValue;

      // Collect currently selected option values from the UI
      const selectedOptions = {};
      this.querySelectorAll('.pickup-availability-pill--selected').forEach(selectedPill => {
        const pos = parseInt(selectedPill.dataset.optionPosition, 10);
        selectedOptions[pos] = selectedPill.dataset.optionValue;
      });

      // Override with the clicked option
      selectedOptions[optionPosition] = optionValue;

      // Parse variants JSON embedded in the drawer
      const variantsScript = this.querySelector('.pickup-availability-variants-json');
      if (!variantsScript) return;

      let variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        return;
      }

      // Find a variant that matches all selected options
      const matchingVariant = variants.find(variant =>
        Object.entries(selectedOptions).every(([pos, value]) => variant[`option${pos}`] === value)
      );

      if (!matchingVariant) return;

      // Get root URL from the pickup-availability element
      const pickupAvailability = document.querySelector('pickup-availability');
      if (!pickupAvailability) return;

      let rootUrl = pickupAvailability.dataset.rootUrl || '';
      if (!rootUrl.endsWith('/')) rootUrl += '/';

      const url = `${rootUrl}variants/${matchingVariant.id}/?section_id=pickup-availability`;

      this.classList.add('pickup-availability-drawer--loading');

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const newHTML = new DOMParser().parseFromString(text, 'text/html');
          const newDrawer = newHTML.querySelector('pickup-availability-drawer');
          if (!newDrawer) {
            this.classList.remove('pickup-availability-drawer--loading');
            return;
          }

          // Swap store list
          const newList = newDrawer.querySelector('[data-store-availability-drawer-content]');
          const currentList = this.querySelector('[data-store-availability-drawer-content]');
          if (newList && currentList) {
            currentList.innerHTML = newList.innerHTML;
          }

          // Swap option pills (reflects new selected + availability state)
          const newOptions = newDrawer.querySelector('.pickup-availability-options');
          const currentOptions = this.querySelector('.pickup-availability-options');
          if (newOptions && currentOptions) {
            currentOptions.innerHTML = newOptions.innerHTML;
            this.initPillListeners();
          }

          // Swap product panel (updates image for selected variant)
          const newProductPanel = newDrawer.querySelector('.pickup-availability-product-panel');
          const currentProductPanel = this.querySelector('.pickup-availability-product-panel');
          if (newProductPanel && currentProductPanel) {
            currentProductPanel.innerHTML = newProductPanel.innerHTML;
          }

          // Keep the pickup-availability element's variant id in sync
          pickupAvailability.dataset.variantId = matchingVariant.id;

          this.classList.remove('pickup-availability-drawer--loading');
          this.markNearestStore();
          this.applySpecialLocationMessages();
          this.applyAvailabilityFilter();
        })
        .catch(() => {
          this.classList.remove('pickup-availability-drawer--loading');
        });
    }

    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      const toRadians = degrees => degrees * Math.PI / 180;
      const R = 6371; // Earth radius in km
      const dLat = toRadians(lat2 - lat1);
      const dLon = toRadians(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    clearNearestStore() {
      this.querySelectorAll('.pickup-availability-list__item--nearest').forEach(item => {
        item.classList.remove('pickup-availability-list__item--nearest');
      });
      this.querySelectorAll('.pickup-availability-nearest-badge').forEach(badge => badge.remove());
    }

    removeLocationHint() {
      this.querySelectorAll('.pickup-availability-location-hint').forEach((el) => el.remove());
    }

    showLocationHint(listRoot, message) {
      if (!listRoot || !message) return;
      this.removeLocationHint();
      const wrapper = listRoot.closest('.pickup-availability-store-list-wrapper') || listRoot.parentElement;
      if (!wrapper) return;
      const hint = document.createElement('p');
      hint.className = 'pickup-availability-location-hint';
      hint.setAttribute('role', 'status');
      hint.textContent = message;
      wrapper.insertBefore(hint, listRoot);
    }

    applyNearestBadge(item, distanceKm) {
      if (!item) return;
      item.classList.add('pickup-availability-list__item--nearest');

      const storeNameWrapper = item.querySelector('.pickup-availability-store-name-wrapper');
      const storeActions = item.querySelector('.pickup-availability-store-actions');
      if (!storeNameWrapper || !storeActions) return;

      const existingBadge = item.querySelector('.pickup-availability-nearest-badge');
      if (existingBadge) return;

      const badge = document.createElement('span');
      badge.className = 'pickup-availability-nearest-badge';
      badge.textContent = `Near you`;
      storeNameWrapper.appendChild(badge);
    }

    sortStoresByDistance(listRoot, userLatitude, userLongitude) {
      const items = Array.from(listRoot.querySelectorAll('.pickup-availability-list__item'));
      if (!items.length) return;

      const withDistance = [];
      const withoutDistance = [];
      items.forEach((item) => {
        const latitude = parseFloat(item.getAttribute('latitude'));
        const longitude = parseFloat(item.getAttribute('longitude'));
        if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
          withoutDistance.push(item);
        } else {
          const distance = this.getDistanceFromLatLonInKm(userLatitude, userLongitude, latitude, longitude);
          withDistance.push({ item, distance });
        }
      });

      withDistance.sort((a, b) => a.distance - b.distance);
      withDistance.forEach(({ item }) => listRoot.appendChild(item));
      withoutDistance.forEach((item) => listRoot.appendChild(item));

      if (withDistance.length) {
        this.applyNearestBadge(withDistance[0].item, withDistance[0].distance);
      }
    }

    markNearestStore() {
      this.clearNearestStore();
      this.removeLocationHint();

      const listRoot = this.querySelector('[data-store-availability-drawer-content]');
      if (!listRoot) return;

      if (!navigator.geolocation) {
        this.showLocationHint(
          listRoot,
          'This browser does not support location, so stores cannot be sorted by distance.'
        );
        return;
      }

      const geoOptions = { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 };

      const onGeolocationError = (error) => {
        let message = '';
        if (error && error.code === 1) {
          message =
            'Location is blocked for this site. Allow location in your browser’s site settings for this shop, then reopen this drawer.';
        } else if (error && error.code === 2) {
          message = 'Your position could not be determined. Try again in a moment.';
        } else if (error && error.code === 3) {
          message = 'Location timed out. Check signal or try closing and reopening this panel.';
        }
        if (message) this.showLocationHint(listRoot, message);
      };

      const runGeolocation = () => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.removeLocationHint();
            this.sortStoresByDistance(
              listRoot,
              position.coords.latitude,
              position.coords.longitude
            );
          },
          onGeolocationError,
          geoOptions
        );
      };

      if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then((result) => {
            if (result.state === 'denied') {
              onGeolocationError({ code: 1 });
              return;
            }
            runGeolocation();
          })
          .catch(() => runGeolocation());
      } else {
        runGeolocation();
      }
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (
        target != this &&
        !target.closest('pickup-availability-drawer') &&
        target.id != 'ShowPickupAvailabilityDrawer' &&
        !target.closest('#ShowPickupAvailabilityDrawer')
      ) {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('pickup-availability--open');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      setScrollbarWidth();
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('pickup-availability--open');
      trapFocus(this);
      this.markNearestStore();
      this.applySpecialLocationMessages();
      this.applyAvailabilityFilter();
    }
  });
}
